import { RecordItem } from "types/common";
import SortedTiles, { SortedTilesProps } from "./SortedTiles";

const SortedTilesServer = (props: SortedTilesProps) => {
  const tileComponents = props.tileComponents;
  const componentsElement = (tileComponents || [])?.map((comp) => {
    let compImport = null;
    try {
      compImport = !comp.component_id.name
        ? null
        : // eslint-disable-next-line @typescript-eslint/no-var-requires
          require(`components/Tiles/TileComponents/${comp.component_id.name}`).default;
    } catch {
      compImport = null;
    }
    return compImport;
  });

  const componentsMap = tileComponents?.reduce((acc: RecordItem, comp, index) => {
    if (comp.component_id?.name) {
      acc[comp.component_id.name] = componentsElement[index];
    }
    return acc;
  }, {});

  return <SortedTiles {...props} componentsMap={componentsMap} />;
};

export default SortedTilesServer;
